import { Link } from "react-router-dom";
import { formatInteger } from "../../services/common/NumberUtil";
import { CompetitionFields } from "./CompetitionFields";
import { CompetitionValues } from "./CompetitionValues";

export default function CompetitionRow({ competition }) {
  return (
    <Link
      to={`/competitions/${competition.id}`}
      className="d-flex  w-100 py-1 text-decoration-none text-dark hover-bg-white"
    >
      <div className="flex-grow-1 pe-2 ps-1">{competition.name}</div>

      <div className="d-flex justify-content-end pe-2">
        {competition.department}
      </div>
      <div
        className="d-flex justify-content-end  pe-2 "
        style={{ width: "100px" }}
      >
        <CompetitionValues
          competition={competition}
          field={CompetitionFields.start_date}
        />
      </div>
    </Link>
  );
}
